export default __webpack_public_path__ + "static/media/application-image.e31deda8.jpg";